import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import React, { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { DeleteVersionContent } from './DeleteVersionContent'

interface IProps {
  selectedVersion: IELTData
  closeDialog: () => void
  show: boolean
}

export const DeleteVersionDialog = ({ selectedVersion, closeDialog, show }: IProps) => {
  const contentProps = useMemo(
    () => ({
      selectedVersion,
      closeDialog,
    }),
    [closeDialog, selectedVersion]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={DeleteVersionContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}
